import React from "react";
import WorkExperience from "./WorkExperience";
import ProfileDataCard from "./ProfileDataCard";

interface OccupationProps {
  occupation: string | null;
  occupationCompany: string | null;
  occupationLocation: string | null;
  occupationStart: Date | null;
  occupationEnd: Date | null;
}

/**
 * This component displays the occupation of an applicant.
 * @param occupation The job title of the applicant.
 * @param occupationCompany The company the applicant worked for.
 * @param occupationLocation The location of the company.
 * @param occupationStart The start date of the occupation.
 * @param occupationEnd The end date of the occupation.
 * @returns The occupation of the applicant.
 */
const Occupation = ({
  occupation,
  occupationCompany,
  occupationLocation,
  occupationStart,
  occupationEnd,
}: OccupationProps) => {
  return (
    <ProfileDataCard title="Berufliche Tätigkeit">
      <WorkExperience
        jobTitle={occupation}
        company={occupationCompany}
        location={occupationLocation}
        start={occupationStart}
        end={occupationEnd}
      />
    </ProfileDataCard>
  );
};

export default Occupation;
